import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useLabratorCreateMutation, useLabratorUpdateMutation } from "store";
import Spinners from "Components/Common/Spinner";
import Flatpickr from "react-flatpickr";



const Organization = (props: any) => {
  const [isLoading, setLoading] = useState(true)

  const [labratorMainData, setLabratorMainData] = useState<any>();
  const [labratorCreate, labratorCreateResult] = useLabratorCreateMutation();
  const [labratorUpdate, labratorUpdateResult] = useLabratorUpdateMutation();
  useEffect(() => {
    if (props?.data === null) {
      setLoading(true)
    } else {
      setLoading(false)
    }
    setLabratorMainData(props?.data);
  }, [props?.data, props?.id, labratorMainData])

  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: labratorMainData?.id,
      lab_description: labratorMainData?.lab_description,
      sampled_date: labratorMainData?.sampled_date,
      registred_date: labratorMainData?.registred_date,
      registred_position: labratorMainData?.registred_position,
      registred_name: labratorMainData?.registred_name,
      dry_residue: labratorMainData?.dry_residue,
      water_hardness: labratorMainData?.water_hardness,
      chemical_formula: labratorMainData?.chemical_formula,
      ph: labratorMainData?.ph,
      sampled_depth: labratorMainData?.sampled_depth,
      water_temperature: labratorMainData?.water_temperature,
      Bacteriological_colititer: labratorMainData?.Bacteriological_colititer,
      Bacteriological_coli_index: labratorMainData?.Bacteriological_coli_index,
      Bacteriological_bacteria_num: labratorMainData?.Bacteriological_bacteria_num,
      mineral_radioactive: labratorMainData?.mineral_radioactive,
      mineral_characteristics_information: labratorMainData?.mineral_characteristics_information,
    },
    validationSchema: Yup.object({
      lab_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sampled_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      registred_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      registred_position: Yup.string().typeError("Текст төрлийн оруулна уу").required("Утга оруулна уу !"),
      registred_name: Yup.string().typeError("Текст төрлийн оруулна уу").required("Утга оруулна уу !"),
      dry_residue: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      water_hardness: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      chemical_formula: Yup.string().typeError("Текст төрлийн оруулна уу").required("Утга оруулна уу !"),
      ph: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      sampled_depth: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      water_temperature: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      Bacteriological_colititer: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      Bacteriological_coli_index: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      Bacteriological_bacteria_num: Yup.number().typeError("Тоон төрлийн оруулна уу").required("Утга оруулна уу !"),
      mineral_radioactive: Yup.string().typeError("Текст төрлийн оруулна уу").required("Утга оруулна уу !"),
      mineral_characteristics_information: Yup.string().typeError("Текст төрлийн оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (labratorMainData !== null) {
        const updateList = {
          id: values.id,
          lab_description: values.lab_description,
          sampled_date: values.sampled_date,
          registred_date: values.registred_date,
          registred_position: values.registred_position,
          registred_name: values.registred_name,
          dry_residue: values.dry_residue,
          water_hardness: values.water_hardness,
          chemical_formula: values.chemical_formula,
          ph: values.ph,
          sampled_depth: values.sampled_depth,
          water_temperature: values.water_temperature,
          Bacteriological_colititer: values.Bacteriological_colititer,
          Bacteriological_coli_index: values.Bacteriological_coli_index,
          Bacteriological_bacteria_num: values.Bacteriological_bacteria_num,
          mineral_radioactive: values.mineral_radioactive,
          mineral_characteristics_information: values.mineral_characteristics_information,

        }
        console.log(labratorMainData);

        labratorUpdate(updateList)
      }
      // validation.resetForm();
    },
  });

  return (
    <>

      {isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >

          <Row>

            <Col lg="4">
              <div className="mb-3">
                <Label className="fw-semibold"> Шинжилсэн лабораторийн нэр </Label>
                <Input
                  name="lab_description"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.lab_description}
                  invalid={
                    validation.touched.lab_description &&
                      validation.errors.lab_description
                      ? true
                      : false
                  }
                />
                {validation.touched.lab_description &&
                  validation.errors.lab_description ? (
                  <FormFeedback type="invalid">
                    {validation.errors.lab_description}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="fw-semibold"> Бүртгэл үйлдсэн хүний албан тушаал   </Label>
                <Input
                  name="registred_position"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.registred_position}
                  invalid={
                    validation.touched.registred_position &&
                      validation.errors.registred_position
                      ? true
                      : false
                  }
                />
                {validation.touched.registred_position &&
                  validation.errors.registred_position ? (
                  <FormFeedback type="invalid">
                    {validation.errors.registred_position}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="fw-semibold"> Ерөнхий хатуулаг, мг-экв/л   </Label>
                <Input
                  name="water_hardness"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.water_hardness}
                  invalid={
                    validation.touched.water_hardness &&
                      validation.errors.water_hardness
                      ? true
                      : false
                  }
                />
                {validation.touched.water_hardness &&
                  validation.errors.water_hardness ? (
                  <FormFeedback type="invalid">
                    {validation.errors.water_hardness}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="fw-semibold"> Дээжилсэн гүн, м   </Label>
                <Input
                  name="sampled_depth"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.sampled_depth}
                  invalid={
                    validation.touched.sampled_depth &&
                      validation.errors.sampled_depth
                      ? true
                      : false
                  }
                />
                {validation.touched.sampled_depth &&
                  validation.errors.sampled_depth ? (
                  <FormFeedback type="invalid">
                    {validation.errors.sampled_depth}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="fw-semibold"> Бактериологийн шинжилгээ коли-индекс   </Label>
                <Input
                  name="Bacteriological_coli_index"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.Bacteriological_coli_index}
                  invalid={
                    validation.touched.Bacteriological_coli_index &&
                      validation.errors.Bacteriological_coli_index
                      ? true
                      : false
                  }
                />
                {validation.touched.Bacteriological_coli_index &&
                  validation.errors.Bacteriological_coli_index ? (
                  <FormFeedback type="invalid">
                    {validation.errors.Bacteriological_coli_index}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3">
                <Label className="fw-semibold"> химийн найрлагын өвөрмөц онцлог үзүүлэлт, ууссан хийн тухай мэдээлэл  </Label>
                <Input
                  name="mineral_characteristics_information"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.mineral_characteristics_information}
                  invalid={
                    validation.touched.mineral_characteristics_information &&
                      validation.errors.mineral_characteristics_information
                      ? true
                      : false
                  }
                />
                {validation.touched.mineral_characteristics_information &&
                  validation.errors.mineral_characteristics_information ? (
                  <FormFeedback type="invalid">
                    {validation.errors.mineral_characteristics_information}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg="4">
              <div className="mb-3">
                <Label className="fw-semibold"> Дээжилсэн огноо  </Label>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="Огноо"
                  name="sampled_date"
                  value={validation.values.sampled_date}
                  onChange={(selectDate: Date[]) => {
                    if (selectDate[0]) {
                      const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                        .toISOString()
                        .split('T')[0];
                      validation.setFieldValue('sampled_date', localDate);
                    }
                  }}
                  options={{
                    altInput: true,
                    altFormat: "Y-m-d",
                    dateFormat: "Y-m-d",
                    enableTime: false,
                  }}
                />
                {validation.touched.sampled_date &&
                  validation.errors.sampled_date ? (
                  <FormFeedback type="invalid">
                    {validation.errors.sampled_date}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="fw-semibold"> Нэр  </Label>
                <Input
                  name="registred_name"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.registred_name}
                  invalid={
                    validation.touched.registred_name &&
                      validation.errors.registred_name
                      ? true
                      : false
                  }
                />
                {validation.touched.registred_name &&
                  validation.errors.registred_name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.registred_name}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="fw-semibold"> Химийн найрлагын томъёо   </Label>
                <Input
                  name="chemical_formula"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.chemical_formula}
                  invalid={
                    validation.touched.chemical_formula &&
                      validation.errors.chemical_formula
                      ? true
                      : false
                  }
                />
                {validation.touched.chemical_formula &&
                  validation.errors.chemical_formula ? (
                  <FormFeedback type="invalid">
                    {validation.errors.chemical_formula}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="fw-semibold"> Усны температур0С </Label>
                <Input
                  name="water_temperature"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.water_temperature}
                  invalid={
                    validation.touched.water_temperature &&
                      validation.errors.water_temperature
                      ? true
                      : false
                  }
                />
                {validation.touched.water_temperature &&
                  validation.errors.water_temperature ? (
                  <FormFeedback type="invalid">
                    {validation.errors.water_temperature}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3">
                <Label className="fw-semibold"> Бактериологийн шинжилгээ бактерийн тоо  </Label>
                <Input
                  name="Bacteriological_bacteria_num"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.Bacteriological_bacteria_num}
                  invalid={
                    validation.touched.Bacteriological_bacteria_num &&
                      validation.errors.Bacteriological_bacteria_num
                      ? true
                      : false
                  }
                />
                {validation.touched.Bacteriological_bacteria_num &&
                  validation.errors.Bacteriological_bacteria_num ? (
                  <FormFeedback type="invalid">
                    {validation.errors.Bacteriological_bacteria_num}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>

            <Col lg="4">
              <div className="mb-3">
                <Label className="fw-semibold"> Бүртгэл үйлдсэн огноо   </Label>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="Огноо"
                  name="registred_date"
                  value={validation.values.registred_date}
                  onChange={(selectDate: Date[]) => {
                    if (selectDate[0]) {
                      const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                        .toISOString()
                        .split('T')[0];
                      validation.setFieldValue('registred_date', localDate);
                    }
                  }}
                  options={{
                    altInput: true,
                    altFormat: "Y-m-d",
                    dateFormat: "Y-m-d",
                    enableTime: false,
                  }}
                />
                {validation.touched.registred_date &&
                  validation.errors.registred_date ? (
                  <FormFeedback type="invalid">
                    {validation.errors.registred_date}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3">
                <Label className="fw-semibold"> Хуурай үлдэгдэл, мг/л   </Label>
                <Input
                  name="dry_residue"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.dry_residue}
                  invalid={
                    validation.touched.dry_residue &&
                      validation.errors.dry_residue
                      ? true
                      : false
                  }
                />
                {validation.touched.dry_residue &&
                  validation.errors.dry_residue ? (
                  <FormFeedback type="invalid">
                    {validation.errors.dry_residue}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3">
                <Label className="fw-semibold"> рН   </Label>
                <Input
                  name="ph"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.ph}
                  invalid={
                    validation.touched.ph &&
                      validation.errors.ph
                      ? true
                      : false
                  }
                />
                {validation.touched.ph &&
                  validation.errors.ph ? (
                  <FormFeedback type="invalid">
                    {validation.errors.ph}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3">
                <Label className="fw-semibold"> Бактериологийн шинжилгээ коли-титр   </Label>
                <Input
                  name="Bacteriological_colititer"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.Bacteriological_colititer}
                  invalid={
                    validation.touched.Bacteriological_colititer &&
                      validation.errors.Bacteriological_colititer
                      ? true
                      : false
                  }
                />
                {validation.touched.Bacteriological_colititer &&
                  validation.errors.Bacteriological_colititer ? (
                  <FormFeedback type="invalid">
                    {validation.errors.Bacteriological_colititer}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3">
                <Label className="fw-semibold"> цацраг идэвхит шинж чанар  </Label>
                <Input
                  name="mineral_radioactive"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.mineral_radioactive}
                  invalid={
                    validation.touched.mineral_radioactive &&
                      validation.errors.mineral_radioactive
                      ? true
                      : false
                  }
                />
                {validation.touched.mineral_radioactive &&
                  validation.errors.mineral_radioactive ? (
                  <FormFeedback type="invalid">
                    {validation.errors.mineral_radioactive}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
            <Col lg={12} className="d-flex justify-content-center mt-3">
              <button type="submit" className="btn btn-primary"> Хадгалах </button>
            </Col>

          </Row>

        </Form>
      }
    </>
  )
}


export default Organization;